import { User } from "@CommonApi/users/list";
import { omniAtom } from "src/utils/atoms";

export const resetPasswordUserAtom = omniAtom({
  key: "modals/resetUserPassword",
  value: null as User | null,
});
